import { render } from "./AICommentDashboard.vue?vue&type=template&id=1195c3a8&scoped=true"
import script from "./AICommentDashboard.vue?vue&type=script&lang=js"
export * from "./AICommentDashboard.vue?vue&type=script&lang=js"

import "./AICommentDashboard.vue?vue&type=style&index=0&id=1195c3a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1195c3a8"]])

export default __exports__